import { base64Uint8Array } from "./utils/base64Uint8Array";

// const base64RegExp = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;

const validBase64Chars = new Set<string>("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""));
const validHexChars = new Set<string>("ABCDEFabcdefx0123456789+/".split(""));

export const isBase64 = (content: string): boolean => {
	if (content.length < 12 || content.length % 4 != 0) return false;
	let hasOnlyHexChars = true;
	let i = 0;
	while (i < content.length && validBase64Chars.has(content.charAt(i))) {
		hasOnlyHexChars = hasOnlyHexChars && validHexChars.has(content.charAt(i));
		i++;
	};
	if (hasOnlyHexChars) return false;
	const charsRemaining = content.length - i;
	if (charsRemaining > 3) return false;
	return charsRemaining === 0 || content.slice(i).split('').every(c => c === "=");
}

export const contentOrBase64DecodedContent = (content: string | undefined): { content: string; decodedFromBase64?: true; } => {
	if (content == null) return { content: "" };
	try {
		const contentIsBase64 = isBase64(content);
		if (contentIsBase64) {
			const decodedContent = new TextDecoder("utf-8", { fatal: true }).decode(base64Uint8Array(content));
			return { content: decodedContent, decodedFromBase64: true };
	}
} catch { }
return { content };
};
